import React, { useState } from 'react';

import Observer from '@researchgate/react-intersection-observer';

import { ReactComponent as Menu1 } from '@assets/images/section-3/menu-1.svg';
import { ReactComponent as Menu2 } from '@assets/images/section-3/menu-2.svg';

import { ReactComponent as Menu1Mob } from '@assets/images/section-3/menu-1-mob.svg';
import { ReactComponent as Menu2Mob } from '@assets/images/section-3/menu-2-mob.svg';

import { ReactComponent as MenuNumber } from '@assets/images/section-3/menu-number.svg';

import { ReactComponent as TextBG1 } from '@assets/images/section-3/text-bg-1.svg';
import { ReactComponent as TextBG2 } from '@assets/images/section-3/text-bg-2.svg';

import { AnimatedImages } from "@ui/moleculs/atoms/AnimatedImage";

import Image1 from '@assets/images/section-3/item-1.webp';
import Image2 from '@assets/images/section-3/item-2.webp';
import Image3 from '@assets/images/section-3/item-3.webp';

import Image1Mob from '@assets/images/section-3/item-1-mob.png';
import Image2Mob from '@assets/images/section-3/item-2-mob.png';

import Image1Safari14 from '@assets/images/section-3/item-1-safari-14.png';
import Image2Safari14 from '@assets/images/section-3/item-2-safari-14.png';
import Image3Safari14 from '@assets/images/section-3/item-3-safari-14.png';

import { AnimatedLinks } from '@ui/moleculs/atoms/AnimatedLinks';

import styles from './index.module.css'

type PageProps = {
  scrollDir?: string;
  isDesktopOrLaptop?: any;
  browser: any;
};

export const Page3: React.FC<PageProps> = ({ ...props }) => {
  const [isVisible, setVisible] = useState([false]);
  const { scrollDir, isDesktopOrLaptop, browser } = props;

  const handleChange = (event: any | never, index: number) => {
    const currActive = isVisible[index];
    const updateArr = [ ...isVisible ];
    updateArr[index] = event.isIntersecting || (currActive && scrollDir === 'down')
    setVisible(updateArr);
  };

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];

  return (
    <Observer
      onChange={event => handleChange(event, 0)}
      root={null}
      rootMargin="0% 0% -20%"
    >
      <article
        id="stage"
        className={`
          ${isVisible[0] ? styles.active : ``}
          ${styles.section}
          relative
          max-w-1100
          w-full
          mx-auto
          text-white

          mb-38
          lg:mb-50
        `}
      >
        <header
          className={`
            flex
            lg:inline-flex
            justify-between
            lg:justify-start
            relative
            -mt-10
            lg:mt-0
            pt-10
            lg:pt-0

            pb-9
            lg:pb-16

            pl-8
            mr-4
            lg:pl-0
            lg:mr-0

            overflow-hidden
            lg:overflow-visible
          `}
        >
          <h1
            className={`
              inline-flex
              flex-col
              items-stretch
              lg:items-start
              relative
              font-bold
              min-w-full
              lg:min-w-0

              text-4xl
              lg:text-6.5xl
            `}
          >
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                <Menu1
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    mt-2
                    -ml-10
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
                :
                <Menu1Mob
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    mt-1.5
                    -ml-0
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              }
              <span className={`relative`}>Основные</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                <Menu2
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    transition-all
                    mt-0
                    -ml-5
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
                :
                <Menu2Mob
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    mt-2.5
                    -ml-5
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              }
              <span className={`relative`}>этапы</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                delay-700
                transition-all
              `}
            >
              <span className={`relative`}>строительства</span>
            </span>
          </h1>
          <h2 className={`
            absolute
            top-0
            lg:-top-10
            right-0
            lg:-right-6
            z-2
          `}>
            <MenuNumber
              width={isDesktopOrLaptop ? 176 : 140}
              height={isDesktopOrLaptop ? 230 : 182}
              className={`
                ${styles.number1}
                relative
                fill-current
              `}
            />
            <MenuNumber
              width={isDesktopOrLaptop ? 176 : 140}
              height={isDesktopOrLaptop ? 230 : 182}
              className={`
                ${styles.number2}
                absolute
                top-0
                right-0
                fill-current
              `}
            />
          </h2>
        </header>

        <Observer
          onChange={event => handleChange(event, 1)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto mb-3.5 lg:mb-15vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[1]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white

                  mb-8
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:text-right
                    lg:mr-11.5
                    mb-1.8
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2015
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}
                >
                  Газпром подписывает соглашение о строительстве «Северного потока-2» с пятью европейскими энергетическими компаниями. <span className={`text-blue-default font-bold`}>В проекте решили принять участие Royal Dutch Shell, E.ON, OMV, Wintershall и ENGIE.</span>
                </span>
              </div>
              <div
                className={`
                  ${isVisible[1]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                  lg:mt-22vw

                  mb-10
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:ml-11.5
                    mb-1.8
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2016
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:ml-11.5
                  `}
                >
                  Начало производства труб для будущего газопровода. Первые трубы были произведены в Германии и прошли бетонирование в Финляндии. <span className={`text-blue-default font-bold`}>Ряд европейских государств выразили протест против реализации проекта.</span>
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 2)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              w-full
              max-w-890
              lg:mx-auto
              mb-15
              lg:mb-15
              overflow-hidden
              lg:overflow-visible
            `}
          >
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[2]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex
                  items-center
                  justify-center
                  lg:justify-end
                  flex-1
                  text-xs
                  lg:text-sm
                  italic
                  indent-sm
                  text-white
                  order-2
                  lg:order-1
                  z-0
                  -mt-5
                  lg:mt-0
                `}
              >
                <TextBG1
                  className={`
                    transform
                    -rotate-180
                    lg:rotate-0
                    relative
                    min-w-110
                    h-auto
                  `}
                />
                <span
                  className={`
                    absolute
                    top-0
                    h-full
                    w-full

                    flex
                    items-center
                    lg:pr-11.5
                    lg:max-w-420
                    px-8
                    lg:px-0
                  `}
                >
                  Трубы для газопровода ​​«Северный поток-2» в порту Мукран на острове Рюген, 4 августа 2021 года, Засница, Германия (Фото: Sean Gallup/Getty Images)
                </span>
              </div>
              <div
                className={`
                  ${isVisible[2]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  flex-1
                  order-1
                  lg:order-2
                  flex
                  justify-center
                  lg:justify-end

                  overflow-hidden
                  lg:overflow-visible

                  z-1
                `}
              >

                {isDesktopOrLaptop ?
                  <AnimatedImages
                    id={`page-3-image-1`}
                    href={(browserName === 'safari' && browserVersion < 15) ? Image1Safari14 : Image1}
                    orientation={`180`}
                    isDesktopOrLaptop={isDesktopOrLaptop}
                  />
                  :
                  <img
                    className={`w-full h-auto`}
                    src={Image1Mob}
                    width={404}
                    height={273}
                    alt=""
                  />
                }
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 3)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto lg:mb-0vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[3]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white

                  mb-10
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:text-right
                    lg:mr-11.5
                    mb-1.8
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2017
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}>
                  <span className={`text-blue-default font-bold`}>Подписаны финансовые соглашения между участниками проекта.</span> Достигнута договорённость о финансировании 50% строительства СП-2 за счёт средств зарубежных компаний. Начата процедура сертификации проекта в Германии.
                </span>
              </div>
              <div
                className={`
                  ${isVisible[3]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                  lg:mt-46vw

                  mb-10
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:ml-11.5
                    mb-1.8
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2018
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:ml-11.5
                  `}
                >
                  Получено разрешение на строительство и эксплуатацию СП-2 в территориальных водах Германии. <span className={`text-blue-default font-bold`}>Начало строительства «Северного потока-2» в Балтийском море.</span>
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 4)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto lg:mb-25vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[4]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white

                  mb-10
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:text-right
                    lg:mr-11.5
                    mb-1.8
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2019
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}
                >
                  <span className={`text-blue-default font-bold`}>Компании, участвовавшие в строительстве «Северного потока-2», получили письма от официальных лиц США с призывом прекратить работы по проекту.</span> 20 декабря издан акт о национальной безопасности США, подразумевающий введение санкций против СП-2. На следующий день компания-трубоукладчик Allseas объявила о выходе из проекта.
                </span>
              </div>
              <div className={`flex-1`} />
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 5)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              w-full
              max-w-890
              lg:mx-auto
              mb-15
              lg:mb-15
              overflow-hidden
              lg:overflow-visible
            `}
          >
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[5]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  flex-1
                  flex
                  lg:block
                  justify-center
                  lg:justify-start

                  overflow-hidden
                  lg:overflow-visible

                  z-1
                `}
              >
                {isDesktopOrLaptop ?
                  <AnimatedImages
                    id={`page-3-image-2`}
                    href={(browserName === 'safari' && browserVersion < 15) ? Image2Safari14 : Image2}
                    isDesktopOrLaptop={isDesktopOrLaptop}
                  />
                  :
                  <img
                    className={`w-full h-auto`}
                    src={Image2Mob}
                    width={404}
                    height={273}
                    alt=""
                  />
                }
              </div>
              <div
                className={`
                  ${isVisible[5]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex
                  align-items
                  justify-center
                  lg:justify-start
                  flex-1
                  text-xs
                  lg:text-sm
                  italic
                  indent-sm
                  text-white
                  z-0
                  -mt-7
                  lg:mt-0
                `}
              >
                <TextBG2
                  className={`
                    relative
                    min-w-110
                    h-auto
                  `}
                />
                <span
                  className={`
                    absolute
                    top-0
                    h-full
                    w-full

                    flex
                    items-center
                    lg:max-w-420
                    lg:pl-11.5
                    px-8
                    lg:px-0
                  `}
                >
                  Вспомогательное судно Calamity Jane в порту города Варна, Болгария, 22 декабря 2019 года (Фото: Impact Press Group/NurPhoto via Getty Images).
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 6)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto mb-20 lg:mb-28vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[6]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  relative
                  flex-1
                  order-2
                  lg:order-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                  lg:mt-40vw

                  mb-10
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:text-right
                    lg:mr-11.5
                    mb-1.8
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2021
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}
                >
                  <span className={`text-blue-default font-bold`}>Строительство газопровода полностью завершено, проведены пусконаладочные работы для контроля целостности объекта.</span> 4 октября оператор Nord Stream 2 AG сообщил, что начал заполнять топливом первую нитку газопровода для достижения нужного давления и дальнейшего технического тестирования. Датское энергетическое агентство заявило, что проект соответствует требованиям и может начать работу. А в правительстве Германии отметили отсутствие препятствий для запуска «Северного потока-2».
                </span>
              </div>
              <div
                className={`
                  ${isVisible[6]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  order-1
                  lg:order-2
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                  mb-10
                  lg:mb-0
                `}
              >
                <h4
                  className={`
                    text-3.5xl
                    lg:text-6.5xl
                    font-bold
                    text-white
                    lg:ml-11.5
                    mb-2
                    indent-sm
                    lg:indent-none
                  `}
                >
                  2020
                </h4>
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:ml-11.5
                  `}
                >
                  Получено разрешение на строительство и эксплуатацию СП-2 в территориальных водах Германии. <span className={`text-blue-default font-bold`}>Начало строительства «Северного потока-2» в Балтийском море.</span>
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 7)}
          root={null}
          rootMargin={isDesktopOrLaptop ? `0% 0% 0%` : `0% 0% 20%`}
        >
          <div
            className={`
              ${isVisible[7]? `animate-opacity` : ``}

              transform
              opacity-0
              translate-y-full
              relative
              z-3
            `}
          >
            <AnimatedLinks
              id={`page3-link1`}
              className={`transform transition-transform duration-1000 lg:hover:scale-110`}
              title={`А у нас в Европе газ: что изменит запуск «Северного потока – 2»`}
              body={`Как в ЕС отреагировали на сварку последней трубы второй нитки газопровода`}
              link={`https://iz.ru/1217962/valerii-voronov-mariia-vasileva/u-nas-v-evrope-gaz-chto-izmenit-zapusk-severnogo-potoka-2`}
              href={(browserName === 'safari' && browserVersion < 15) ? Image3Safari14 : Image3}
              size={`sm`}
              isDesktopOrLaptop={isDesktopOrLaptop}
            />
          </div>
        </Observer>

      </article>
    </Observer>
  );
}